import type { ReactNode } from 'react';
import { BRAND } from '@/config/brand';

interface AuthCardProps {
  /** Optional heading below the logo; leave empty for logo-only auth screens. */
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  showLogo?: boolean;
}

export function AuthCard({ title = '', children, footer, showLogo = true }: AuthCardProps) {
  return (
    <div className="animate-fade-in rounded-2xl border border-slate-200/80 bg-white/95 p-8 shadow-xl shadow-slate-200/50 backdrop-blur-sm dark:border-slate-700/80 dark:bg-slate-900/95 dark:shadow-black/30">
      {showLogo ? (
        <div className="mb-6 flex justify-center">
          <img
            src={BRAND.logoPath}
            alt="Logo"
            className="h-11 w-auto max-w-[240px] object-contain sm:h-12"
            width={240}
            height={48}
          />
        </div>
      ) : null}
      {title.trim() ? (
        <h2 className="text-center text-lg font-semibold tracking-tight text-slate-900 dark:text-white">{title}</h2>
      ) : null}
      <div className={title.trim() ? 'mt-6' : undefined}>{children}</div>
      {footer ? <div className="mt-6 border-t border-slate-100 pt-4 dark:border-slate-800">{footer}</div> : null}
    </div>
  );
}
